import { render, staticRenderFns } from "./PointsHistory.vue?vue&type=template&id=d87f7f9e&scoped=true"
import script from "./PointsHistory.vue?vue&type=script&lang=js"
export * from "./PointsHistory.vue?vue&type=script&lang=js"
import style0 from "./PointsHistory.vue?vue&type=style&index=0&id=d87f7f9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87f7f9e",
  null
  
)

export default component.exports